import React from 'react';
import { ComponentTypes } from 'logi-embed/types';
import { LogiComponent } from '../LogiComponent';
/**
 * LogiVisualBuilder component. Can be used to build new visuals or edit existing
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.configuration - The configuration object.
 * @param {Function} props.getToken - The function to get the token.
 * @param {string} props.logiBaseUrl - The base URL for Logi Composer.
 * @param {string} props.visualBuilderStyleWidth - The width style for the visual builder.
 * @param {string} props.visualBuilderStyleHeight - The height style for the visual builder.
 */
export const LogiVisualBuilder = ({ configuration, getToken, logiBaseUrl, visualBuilderStyleWidth, visualBuilderStyleHeight, }) => {
    return (React.createElement(LogiComponent, { componentType: ComponentTypes.VISUAL_BUILDER, configuration: configuration, getToken: getToken, logiBaseUrl: logiBaseUrl, styleWidth: visualBuilderStyleWidth, styleHeight: visualBuilderStyleHeight, ariaLabel: 'Logi Visual Builder' }));
};
